/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const TrophyIcon = /*#__PURE__*/ createSvgIcon(
  'TrophyIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.167 15.833V13.25a4.475 4.475 0 01-1.823-.865 3.733 3.733 0 01-1.177-1.593 4.045 4.045 0 01-2.615-1.365A4.01 4.01 0 012.5 6.667v-.834c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49h1.666c0-.458.164-.85.49-1.176.326-.327.719-.49 1.177-.49h5c.458 0 .85.163 1.177.49.327.326.49.718.49 1.177h1.666c.459 0 .851.163 1.177.49.327.326.49.718.49 1.176v.834a4.01 4.01 0 01-1.052 2.76 4.045 4.045 0 01-2.615 1.365 3.732 3.732 0 01-1.177 1.593 4.474 4.474 0 01-1.823.865v2.583h2.5c.236 0 .434.08.594.24.16.16.24.358.24.594s-.08.434-.24.593a.807.807 0 01-.594.24H6.667a.806.806 0 01-.594-.24.806.806 0 01-.24-.593c0-.236.08-.434.24-.594.16-.16.358-.24.594-.24h2.5zM5.833 9V5.833H4.167v.834c0 .527.152 1.003.458 1.427.306.423.708.725 1.208.906zM10 11.667c.694 0 1.285-.243 1.77-.73.487-.486.73-1.076.73-1.77v-5h-5v5c0 .694.243 1.284.73 1.77.485.487 1.076.73 1.77.73zM14.167 9c.5-.18.902-.483 1.208-.906.306-.424.458-.9.458-1.427v-.834h-1.666V9z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default TrophyIcon;
